(function () {
  'use strict';

  var modal = document.getElementById('quick-view-modal');
  if (!modal) return;

  var imageEl = document.getElementById('quick-view-image');
  var titleEl = document.getElementById('quick-view-title');
  var priceEl = document.getElementById('quick-view-price');
  var optionsEl = document.getElementById('quick-view-options');
  var addBtn = document.getElementById('quick-view-add');
  var statusEl = document.getElementById('quick-view-status');
  var fullLinkEl = document.getElementById('quick-view-fulllink');

  var currentProduct = null;
  var selectedOptions = [];
  var lastFocusedEl = null;

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function findVariant(product, options) {
    for (var i = 0; i < product.variants.length; i++) {
      var v = product.variants[i];
      var matches = true;
      for (var j = 0; j < options.length; j++) {
        if (v.options[j] !== options[j]) {
          matches = false;
          break;
        }
      }
      if (matches) return v;
    }
    return null;
  }

  function variantAvailableForOptionValue(product, optionIndex, value) {
    var testOptions = selectedOptions.slice();
    testOptions[optionIndex] = value;
    for (var i = 0; i < product.variants.length; i++) {
      var v = product.variants[i];
      var matches = true;
      for (var j = 0; j < testOptions.length; j++) {
        if (testOptions[j] && v.options[j] !== testOptions[j]) {
          matches = false;
          break;
        }
      }
      if (matches && v.available) return true;
    }
    return false;
  }

  function renderOptions(product) {
    optionsEl.innerHTML = '';
    if (product.options.length === 1 && product.options[0] === 'Title') {
      return;
    }
    product.options.forEach(function (optionName, optionIndex) {
      var values = [];
      product.variants.forEach(function (v) {
        var val = v.options[optionIndex];
        if (values.indexOf(val) === -1) values.push(val);
      });

      var group = document.createElement('div');
      group.className = 'quick-view-option-group';

      var label = document.createElement('span');
      label.className = 'quick-view-option-label';
      label.textContent = optionName;
      group.appendChild(label);

      values.forEach(function (value) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'quick-view-option-value';
        btn.textContent = value;
        btn.dataset.optionIndex = optionIndex;
        btn.dataset.value = value;
        if (selectedOptions[optionIndex] === value) {
          btn.classList.add('is-selected');
        }
        if (!variantAvailableForOptionValue(product, optionIndex, value)) {
          btn.disabled = true;
        }
        btn.addEventListener('click', function () {
          selectedOptions[optionIndex] = value;
          renderOptions(product);
          updateSelection(product);
        });
        group.appendChild(btn);
      });

      optionsEl.appendChild(group);
    });
  }

  function updateSelection(product) {
    var variant = findVariant(product, selectedOptions);
    if (variant) {
      priceEl.textContent = formatMoney(variant.price);
      addBtn.disabled = !variant.available;
      addBtn.textContent = variant.available ? 'Add to cart' : 'Sold out';
      addBtn.dataset.variantId = variant.id;
      if (variant.featured_image) {
        imageEl.src = variant.featured_image.src.replace(/(\.[a-zA-Z]+)(\?|$)/, '_600x$1$2');
      }
    } else {
      addBtn.disabled = true;
      addBtn.textContent = 'Unavailable';
      addBtn.removeAttribute('data-variant-id');
    }
    statusEl.textContent = '';
  }

  function openModalWithProduct(product) {
    currentProduct = product;
    selectedOptions = [];
    var firstVariant = product.variants.find(function (v) { return v.available; }) || product.variants[0];
    if (firstVariant) {
      selectedOptions = firstVariant.options.slice();
    }

    titleEl.textContent = product.title;
    fullLinkEl.href = product.url;
    var img = product.featured_image || (product.images && product.images[0]);
    imageEl.src = img ? img.replace(/(\.[a-zA-Z]+)(\?|$)/, '_600x$1$2') : '';
    imageEl.alt = product.title;

    renderOptions(product);
    updateSelection(product);

    lastFocusedEl = document.activeElement;
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    modal.querySelector('.quick-view-modal__close').focus();
  }

  function closeModal() {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    statusEl.textContent = '';
    if (lastFocusedEl) lastFocusedEl.focus();
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('.quick-view-trigger');
    if (trigger) {
      e.preventDefault();
      var handle = trigger.dataset.quickViewHandle;
      statusEl.textContent = '';
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      titleEl.textContent = 'Loading…';
      priceEl.textContent = '';
      optionsEl.innerHTML = '';
      imageEl.src = '';
      fetch('/products/' + handle + '.js')
        .then(function (res) { return res.json(); })
        .then(function (product) {
          openModalWithProduct(product);
        })
        .catch(function () {
          titleEl.textContent = 'Could not load product';
        });
      return;
    }

    if (e.target.closest('[data-quick-view-close]')) {
      closeModal();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal.classList.contains('is-open')) {
      closeModal();
    }
  });

  addBtn.addEventListener('click', function () {
    var variantId = addBtn.dataset.variantId;
    if (!variantId) return;

    addBtn.disabled = true;
    statusEl.textContent = 'Adding…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('add failed');
        return res.json();
      })
      .then(function () {
        statusEl.textContent = 'Added to cart';
        addBtn.disabled = false;
        return fetch('/cart.js');
      })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var bubble = document.querySelector('.cart-count-bubble span');
        if (bubble) bubble.textContent = cart.item_count;
      })
      .catch(function () {
        statusEl.textContent = 'Could not add to cart';
        addBtn.disabled = false;
      });
  });
})();
